import { render, staticRenderFns } from "./ReportItems.vue?vue&type=template&id=177c821a&scoped=true"
import script from "./ReportItems.vue?vue&type=script&lang=js"
export * from "./ReportItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c821a",
  null
  
)

export default component.exports